import React, { useState, useEffect } from "react";
import { Container, Form, Row, Col, Button, Spinner } from "react-bootstrap";
import { Accordion, AccordionItem, AccordionBody } from "react-bootstrap";
import { toast } from "react-toastify";
import { getDocumentTypeData, saveDocumentType } from "../Api/Reconciliation";

import "../Styling/Title.css";
import "../Styling/Accordion.css";
import "../Styling/SaveButton.css";
import "../Styling/ResetButton.css";

const BankRecoDocType = () => {
  const [docTypes, setDocTypes] = useState([]);
  const [formData, setFormData] = useState({
    docType: "",
    matchingDocType: "",
    PostedGl: "",
    MatchingGl: "",
    PostedPk: "",
    MatchingPk: "",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchDocTypes = async () => {
      try {
        const response = await getDocumentTypeData();
        setDocTypes(response || []);
      } catch (error) {
        toast.error("Failed to load document types");
      }
    };
    fetchDocTypes();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.docType || !formData.matchingDocType) {
      toast.error("Please select both Doc Type and Matching Doc Type");
      return;
    }

    const payload = {
      docType: formData.docType,
      matchingDocType: formData.matchingDocType,
      PostedGl: formData.PostedGl,
      MatchingGl: formData.MatchingGl,
      PostedPk: formData.PostedPk,
      MatchingPk: formData.MatchingPk,
    };

    console.log("Saving Document Type:", payload);

    try {
      setLoading(true);
      await saveDocumentType(payload);

      toast.success("Document Type saved successfully ✅");

      setFormData({
        docType: "",
        matchingDocType: "",
        PostedGl: "",
        MatchingGl: "",
        PostedPk: "",
        MatchingPk: "",
      });
    } catch (error) {
      toast.error(error.message || "Failed to save document type ❌");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container asset-master-fields">
      <h2 className="fields-title">Bank Reconciliation Document Type</h2>

      <Form onSubmit={handleSubmit} className="fields-form">

        <Accordion defaultActiveKey="0">

          <AccordionItem eventKey="0">
            <AccordionBody>

              <Row className="g-3">

                {/* Doc Type */}
                <Col xl={6} lg={6} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>
                      Doc Type <span className="text-danger">*</span>
                    </Form.Label>

                    <Form.Select
                      name="docType"
                      value={formData.docType}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Doc Type</option>

                      {docTypes.map((item, idx) => (
                        <option key={idx} value={item.code}>
                          {item.code} - {item.description}
                        </option>
                      ))}

                    </Form.Select>
                  </Form.Group>
                </Col>

                {/* Matching Doc Type */}
                <Col xl={6} lg={6} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>
                      Matching Doc Type <span className="text-danger">*</span>
                    </Form.Label>

                    <Form.Select
                      name="matchingDocType"
                      value={formData.matchingDocType}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Matching Doc Type</option>

                      {docTypes.map((item, idx) => (
                        <option key={idx} value={item.code}>
                          {item.code} - {item.description}
                        </option>
                      ))}

                    </Form.Select>
                  </Form.Group>
                </Col>

                {/* Posted GL */}
                <Col xl={6} lg={6} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>Posted GL</Form.Label>

                    <Form.Control
                      type="text"
                      name="PostedGl"
                      value={formData.PostedGl}
                      onChange={handleChange}
                      placeholder="Enter Posted GL"
                    />
                  </Form.Group>
                </Col>

                {/* Matching GL */}
                <Col xl={6} lg={6} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>Matching GL</Form.Label>

                    <Form.Control
                      type="text"
                      name="MatchingGl"
                      value={formData.MatchingGl}
                      onChange={handleChange}
                      placeholder="Enter Matching GL"
                    />
                  </Form.Group>
                </Col>

                {/* Posted PK */}
                <Col xl={6} lg={6} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>Posted PK</Form.Label>

                    <Form.Control
                      type="text"
                      name="PostedPk"
                      value={formData.PostedPk}
                      onChange={handleChange}
                      placeholder="Enter Posted PK"
                    />
                  </Form.Group>
                </Col>

                {/* Matching PK */}
                <Col xl={6} lg={6} md={6} sm={12}>
                  <Form.Group>
                    <Form.Label>Matching PK</Form.Label>

                    <Form.Control
                      type="text"
                      name="MatchingPk"
                      value={formData.MatchingPk}
                      onChange={handleChange}
                      placeholder="Enter Matching PK"
                    />
                  </Form.Group>
                </Col>

              </Row>

            </AccordionBody>
          </AccordionItem>

        </Accordion>

        {/* Submit Button */}

        <div className="mt-4 text-center">
          <Button
            type="submit"
            className="fields-submit"
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Document Type"}
          </Button>
        </div>

      </Form>
    </div>
  );
};

export default BankRecoDocType;

// import React, { useState, useEffect } from "react";
// import { Container, Form, Row, Col, Button } from "react-bootstrap";
// import { toast } from "react-toastify";
// import { getDocumentTypeData, saveDocumentType } from "../Api/Reconciliation";

// const BankRecoDocType = () => {
//   const [docTypes, setDocTypes] = useState([]);
//   const [formData, setFormData] = useState({
//     docType: "",
//     matchingDocType: "",
//   });
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     const fetchDocTypes = async () => {
//       try {
//         const response = await getDocumentTypeData();
//         setDocTypes(response || []);
//       } catch (error) {
//         toast.error("Failed to load document types");
//       }
//     };
//     fetchDocTypes();
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!formData.docType || !formData.matchingDocType) {
//       toast.error("Please select both Doc Type and Matching Doc Type");
//       return;
//     }

//     const payload = {
//       docType: formData.docType, // only code
//       matchingDocType: formData.matchingDocType, // only code
//     };
//     console.log("Saving Document Type:", payload);

//     try {
//       setLoading(true);
//       await saveDocumentType(payload);
//       toast.success("Document Type saved successfully ✅");
//       setFormData({ docType: "", matchingDocType: "" }); // reset
//     } catch (error) {
//       toast.error(error.message || "Failed to save document type ❌");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="main-content expand">
//       <Container fluid className="fields-container">
//         <h2 className="fields-title">Bank Reconciliation Document Type</h2>
//         <Form className="fields-form" onSubmit={handleSubmit}>
//           <Row>
//             {/* DocType Dropdown */}
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   Doc Type <span className="text-red">**</span>
//                 </Form.Label>
//                 <Form.Select
//                   name="docType"
//                   value={formData.docType}
//                   onChange={handleChange}
//                   required
//                 >
//                   <option value="">Select Doc Type</option>
//                   {docTypes.map((item, idx) => (
//                     <option key={idx} value={item.code}>
//                       {item.code} - {item.description}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//             </Col>

//             {/* Matching DocType Dropdown */}
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   Matching Doc Type <span className="text-red">**</span>
//                 </Form.Label>
//                 <Form.Select
//                   name="matchingDocType"
//                   value={formData.matchingDocType}
//                   onChange={handleChange}
//                   required
//                 >
//                   <option value="">Select Matching Doc Type</option>
//                   {docTypes.map((item, idx) => (
//                     <option key={idx} value={item.code}>
//                       {item.code} - {item.description}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>

//           <div className="fields-btn-container">
//             <Button
//               type="submit"
//               variant="primary"
//               className="fields-submit"
//               disabled={loading}
//             >
//               {loading ? "Saving..." : "Save Document Type"}
//             </Button>
//           </div>
//         </Form>
//       </Container>
//     </div>
//   );
// };

// export default BankRecoDocType;
